import React from 'react';
import { NAV } from '@/constants/testIds';
import { useDashboard } from '@/context/DashboardContext';
import { Printer, Download } from 'lucide-react';

export default function Topbar() {
  const { fy, setFy, FYS } = useDashboard();

  return (
    <>
      <header className="topbar">
        <div className="flex items-center gap-2.5" data-testid={NAV.brand}>
          <div className="brand-mark">
            <span className="b1" /><span className="b2" /><span className="b3" /><span className="b4" /><span className="b5" />
          </div>
          <div className="leading-tight">
            <b className="block text-[13px] font-extrabold tracking-[0.04em] text-white">SAHAYA FOUNDATION</b>
            <small className="text-[9px] tracking-[0.14em] text-[color:var(--llf-gold)] font-semibold uppercase">
              Where hope meets action
            </small>
          </div>
        </div>

        <div className="text-[13px] text-white/70 border-l border-white/20 pl-4">
          Donor Management · <b className="text-white font-semibold">CEO &amp; Trustee View</b>
        </div>

        <div className="ml-auto flex items-center gap-2.5">
          <div className="flex items-center gap-1.5 bg-white/10 border border-white/15 rounded-lg px-2.5 py-1 text-xs text-white/85">
            FY
            <select
              data-testid={NAV.fy}
              value={fy}
              onChange={(e) => setFy(e.target.value)}
              className="bg-transparent border-none text-[color:var(--llf-gold)] font-bold text-xs outline-none cursor-pointer"
            >
              {FYS.map((f) => (
                <option key={f} value={f} className="text-gray-800">
                  {f.replace('FY ', '')}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            data-testid={NAV.print}
            onClick={() => window.print()}
            className="inline-flex items-center gap-1.5 bg-white/10 border border-white/15 text-white rounded-lg px-3 py-1.5 text-xs font-medium hover:bg-white/20 transition-colors"
          >
            <Printer size={12} /> Print
          </button>
          <button
            type="button"
            data-testid={NAV.export}
            onClick={() => window.print()}
            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-bold text-[color:var(--llf-ink)] transition-colors"
            style={{ background: 'var(--llf-gold)', border: '1px solid var(--llf-gold)' }}
          >
            <Download size={12} /> Export Report
          </button>

          <span className="text-[10px] font-bold tracking-widest rounded-full px-2.5 py-1 text-white" style={{ background: 'var(--red-600)' }}>
            MOCK
          </span>

          <div className="flex items-center gap-2 pl-2 border-l border-white/20">
            <div
              className="w-[30px] h-[30px] rounded-full flex items-center justify-center text-[11px] font-extrabold"
              style={{ background: 'var(--llf-gold)', color: 'var(--llf-ink)' }}
            >
              SM
            </div>
            <div className="leading-[1.15]">
              <div className="text-[11.5px] font-semibold text-white">Santanu Mishra</div>
              <div className="text-[9.5px] text-white/60">Executive Trustee · CEO view</div>
            </div>
          </div>
        </div>
      </header>
      <div className="ribbon" />
    </>
  );
}
